import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicFAtoRE = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Finite Automata to Regular Expression"
      videos={[
        "https://www.youtube.com/embed/OsTphhnaXio", // Arden's Method
        "https://www.youtube.com/embed/SmT1DXLl3f4",
        "https://www.youtube.com/embed/qgm5qHgwp3g", // State Elimination Method
        "https://www.youtube.com/embed/Jq3PJFQF7WY",
        "https://www.youtube.com/embed/KLBzsS0NzIo", // RIJ K Method
      ]}
      takeaways={[
        { text: "Learn Arden's method for converting Finite Automata to Regular Expressions." },
        { text: "Understand the State Elimination method for DFA to RE conversion." },
        { text: "Explore the RIJ K method for conversion." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicFAtoRE };
